module.exports = __webpack_public_path__ + "8ce14e65850345cc9542e21ece70f344.gif";